// extracted by mini-css-extract-plugin
export var label = "_fl-2";
export var slideContainer = "_fl-0";
export var slider = "_fl-1";